let gtmContainers = new Set();
let yandexCounters = new Set();

export function initGtm(containerId, dataLayerName = 'dataLayer') {
  if (!containerId || gtmContainers.has(containerId)) return;
  gtmContainers.add(containerId);

  const script = document.createElement('script');
  script.id = `gtm-metrika-${containerId}`;
  script.type = 'text/javascript';
  script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='${dataLayerName}'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','${dataLayerName}','${containerId}');`;

  const head = document.head || document.getElementsByTagName('head')[0];
  if (head) head.appendChild(script);
  else document.documentElement.prepend(script);
}

// универсалка для внешних скриптов
export function addScriptOnce(src, id, async = true, parent = document.body) {
  if (!src || document.getElementById(id)) return;
  const s = document.createElement('script');
  s.id = id;
  s.async = !!async;
  s.src = src;
  parent.prepend(s);
}

// Jivo
export function initJivo(widgetKey) {
  if (!widgetKey) return;
  addScriptOnce(`//code.jivosite.com/widget/${widgetKey}`, 'jivo-script');
}

// Яндекс.Метрика inline в <head>
export function initYandex(counterId, options = {
  webvisor: true,
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  ecommerce: "dataLayer"
}) {
  const id = String(counterId || '').trim();
  if (!id || yandexCounters.has(id)) return;
  yandexCounters.add(id);

  const script = document.createElement('script');
  script.id = `ym-metrika-${id}`;
  script.type = 'text/javascript';
  script.text = `(function(m,e,t,r,i,k,a){
  m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
  m[i].l=1*new Date();
  for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
  k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
})(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${id}', 'ym');
ym(${id}, 'init', ${JSON.stringify(options)});`;

  const head = document.head || document.getElementsByTagName('head')[0];
  if (head) head.appendChild(script);
  else document.documentElement.prepend(script);
}
